import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { ProviderIcon } from '@root/entities/provider/ui'

import type { Provider } from '@root/entities/provider'

type PairListItemProviderProps = {
  provider: Provider.Provider
}

export const PairListItemProvider: React.FC<PairListItemProviderProps> = ({
  provider,
}) => {
  return (
    <Root>
      <ProviderIcon size={12} provider={provider} />
      <Title>{provider.title}</Title>
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-gap: 4px;
  align-items: center;
`

const Title = styled(Typography).attrs({
  variant: 'body4-medium',
  component: 'div',
})`
  color: var(--text-11);
  white-space: nowrap;
`
